import cx from 'classnames'

type Props = {
  iconPath?: string
  tranparent?: boolean
  children: string
}

export const ChatMessageReplyPreviewText = ({
  iconPath,
  tranparent,
  children = '',
}: Props) => {
  if (!children) return null

  return (
    <div
      className={cx('ChatMessageReplyPreviewText', {
        'ChatMessageReplyPreviewText--transparent': tranparent,
      })}
    >
      {iconPath && (
        <div
          className="ChatMessageReplyPreviewText__icon"
          style={{ '--mask-url': `url(${iconPath})` } as any}
        ></div>
      )}
      <span>{children}</span>
    </div>
  )
}
